module.exports = __webpack_public_path__ + "img/yanhua.271c2553.png";